<script setup>
import {APP} from "@/config/app";
</script>

<template>
  <div class="absolute top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 dark:bg-gray-800 opacity-75 flex flex-col items-center justify-center">
    <div class="ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 mb-4" :class="[ APP.MyWealthMode ? 'loader' : 'font-madera mwi-loader']"></div>
    <h2 class="text-center text-white text-xl font-semibold mb-4"><slot /></h2>
    <p class="w-1/3 text-center text-white">This may take a few seconds.</p>
  </div>
</template>
<style>
.loader {
  border-top-color: #223F34;
  -webkit-animation: spinner 1.5s linear infinite;
  animation: spinner 1.5s linear infinite;
}

.mwi-loader {
    border-top-color: #13625A;
    -webkit-animation: spinner 1.5s linear infinite;
    animation: spinner 1.5s linear infinite;
}

@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>
